import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { ChartFormSubsection } from "modules/charts-shared";

function useArrivalInfo(encounterId: string) {
  return useAxiosQuery(["arrivalInfo", { encounterId }], () =>
    axiosChartInstance.get<ChartFormSubsection[]>(
      `v1/triage/${encounterId}/arrival-info`
    )
  );
}

export { useArrivalInfo };
